import React from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";

import useCampuses from "../hooks/useCampuses";
import useTransportGroupsByDate from "../hooks/useTransportGroupsByDate";
import CampusTransportBoard from "./boards/CampusTransportBoard";

export default function TransportPage({
  selectedDate,
  setSelectedDate,
  selectedCampusId,
  setSelectedCampusId,
}) {

  const { campuses = [], loading: campusesLoading } = useCampuses();
  const { groups = [], loading, error, refetch } = useTransportGroupsByDate(selectedDate);

  const confirmedCount = (groups || []).filter(g => String(g.status).toLowerCase() === "confirmed").length;
  const plannedCount = (groups || []).filter(g => String(g.status).toLowerCase() === "planned").length;

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Stack>
          <Typography variant="h5" fontWeight={800}>Transport Plan</Typography>
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            {selectedDate.format("dddd D MMM YYYY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Chip label={`Confirmed ${confirmedCount}`} />
          <Chip label={`Planned ${plannedCount}`} />
          <Chip label={`Total ${(groups || []).length}`} />
        </Stack>
      </Stack>

      <CampusTransportBoard
        campuses={campuses}
        campusesLoading={campusesLoading}
        journeys={groups}
        loading={loading}
        error={error}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedCampusId={selectedCampusId}
        setSelectedCampusId={setSelectedCampusId}
        onRefresh={() => refetch?.(selectedDate)}
      />
    </Box>
  );
}
